import React, { useState } from "react";
import SectionTitle from "./SectionTitle";
import GuestScrollReveal from "./GuestScrollReveal";
import GuestSelect from "./GuestSelect";
import { SUPPORT_TOPICS, GUEST_SECTION_IDS } from "../../data/guestPageData";
import { supportService } from "../../api/services/supportService";
import { VALIDATION } from "../../utils/constants";

const SupportSection = ({ onSuccess, onError }) => {
    const [form, setForm] = useState({
        topic: "",
        name: "",
        email: "",
        message: "",
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!form.topic || !form.name || !form.email || !form.message) {
            onError?.("Заполните все обязательные поля");
            return;
        }

        if (!VALIDATION.EMAIL_REGEX.test(form.email)) {
            onError?.("Введите корректный email");
            return;
        }

        setIsSubmitting(true);

        try {
            await supportService.sendMessage(form);
            setForm({ topic: "", name: "", email: "", message: "" });
            onSuccess?.(
                "Сообщение отправлено. Мы свяжемся с вами в ближайшее время.",
            );
        } catch {
            onError?.(
                "Не удалось отправить сообщение. Попробуйте позже или напишите нам в соцсетях.",
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <section
            className="guest-section guest-section--support"
            id={GUEST_SECTION_IDS.support}
        >
            <GuestScrollReveal>
                <SectionTitle>
                    <span>
                        НАША СЛУЖБА{" "}
                        <span className="guest-section-title__accent">
                            ПОДДЕРЖКИ НАХОДИТСЯ{" "}
                        </span>
                        С ВАМИ{" "}
                        <span className="guest-section-title__accent">
                            НА СВЯЗИ 24/7
                        </span>{" "}
                    </span>
                </SectionTitle>
            </GuestScrollReveal>

            <GuestScrollReveal delay={0.08}>
                <div className="guest-section__content">
                    <form
                        className="guest-support-form"
                        onSubmit={handleSubmit}
                    >
                        <h3 className="guest-support-form__title">
                            СЛУЖБА ПОДДЕРЖКИ
                        </h3>

                        <div className="guest-support-form__field guest-support-form__field--full">
                            <GuestSelect
                                name="topic"
                                value={form.topic}
                                onChange={handleChange}
                                placeholder="Тема обращения*"
                                required
                                options={SUPPORT_TOPICS.map((topic) => ({
                                    value: topic,
                                    label: topic,
                                }))}
                            />
                        </div>

                        <div className="guest-support-form__row">
                            <label className="guest-support-form__field">
                                <span className="visually-hidden">Имя</span>
                                <input
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    placeholder="Имя*"
                                    required
                                />
                            </label>
                            <label className="guest-support-form__field">
                                <span className="visually-hidden">Email</span>
                                <input
                                    type="email"
                                    name="email"
                                    value={form.email}
                                    onChange={handleChange}
                                    placeholder="Email*"
                                    required
                                />
                            </label>
                        </div>

                        <label className="guest-support-form__field guest-support-form__field--full">
                            <span className="visually-hidden">Сообщение</span>
                            <textarea
                                name="message"
                                value={form.message}
                                onChange={handleChange}
                                placeholder="Сообщение"
                                rows={6}
                                required
                            />
                        </label>

                        <button
                            type="submit"
                            className="guest-support-form__submit"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "Отправка..." : "Отправить"}
                        </button>
                    </form>
                </div>
            </GuestScrollReveal>
        </section>
    );
};

export default SupportSection;
